module.exports = __webpack_public_path__ + "img/gate_thumb.bace6ca3.jpg";